import React, { useEffect, useState } from "react";
import { ThreeDots, TailSpin } from "react-loader-spinner";
import Snackbar from "@mui/material/Snackbar";
import Pagination from "@mui/material/Pagination";
import BaseLayout from "../../layout/BaseLayout";

import SearchIcon from "@mui/icons-material/Search";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import {
  ajoutUtilisateur,
  changerEtatUtilisateurParId,
  getListeUtilisateur,
  modificationUtilisateur,
  rechercherUtilisateurParParam,
  supprimerUtilisateurParId,
} from "../../services/utilisateurs/UtilisateursRequest";
import { useNavigate } from "react-router-dom";

const Caissiere = () => {
  const navigate = useNavigate();
  const [pageQuery, setPageQuery] = useState({
    page: 0,
    size: 7,
    nombrePage: 1,
  });
  const [loadingData, setLoadingData] = useState(true);
  const [successMessage, setSuccessMessage] = useState(false);
  const [errorMessage, setErrorMessage] = useState(false);
  const [snackbarSuccessOpen, setSnackbarOpenSuccess] = useState(false);
  const [snackbarErrorOpen, setSnackbarOpenError] = useState(false);
  const [snackbarPosition, setSnackbarPosition] = useState({
    vertical: "bottom",
    horizontal: "center",
  });
  const [searchLoading, setSearchLoading] = useState(false);
  const [addLoading, setAddLoading] = useState(false);
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [desactiveLoading, setDesactiveLoading] = useState(false);
  const [userInfo, setUserInfo] = useState(null);
  const [userListe, setUserListe] = useState([]);

  const [nom, setNom] = useState("");
  const [prenoms, setPrenoms] = useState("");
  const [numero, setNumero] = useState("");
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");

  const [searchTerm, setSearchTerm] = useState("");

  const { vertical, horizontal } = snackbarPosition;

  const TableElement = ({ user }) => {
    return (
      <tr>
        <td className="px-4">
          {user.nom} {user.prenoms}
        </td>
        <td className="px-4">{user.numero}</td>
        {/* <td className="px-4">{user.profil}</td> */}
        <td className="w-40 px-4">
          <div className="flex items-center gap-x-3">
            <label
              htmlFor="delete-warning"
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => {
                document.getElementById("delete-warning").click();
                setUserInfo(user);
              }}
            >
              <DeleteIcon />
            </label>
            <button
              className="bg-gray-100 p-1 rounded-md text-gray-700 cursor-pointer"
              onClick={() => modalEditUtilisateur(user)}
            >
              <EditIcon />
            </button>
            <button
              className={
                user.enabled
                  ? "bg-red-100 px-4 py-1 rounded-md font-medium text-red-500 text-sm cursor-pointer"
                  : "bg-green-100 px-4 py-1 rounded-md font-medium text-green-500 text-sm cursor-pointer"
              }
              onClick={() => modalDesactive(user)}
            >
              {user.enabled ? "Désactiver" : "Activer"}
            </button>

            <label htmlFor="desactive-warning"></label>
          </div>
        </td>
      </tr>
    );
  };

  const modalDesactive = (user) => {
    setUserInfo(user);
    document.getElementById("desactive-warning").click();
  };

  const modalEditUtilisateur = (user) => {
    document.getElementById("ajout-utilisateur").click();
    setUserInfo(user);
    setNom(user.nom);
    setPrenoms(user.prenoms);
    setNumero(user.numero);
    setUsername(user.email);
  };

  const modalCreateUtilisateur = () => {
    setUserInfo(null);
    setNom("");
    setPrenoms("");
    setNumero("");
    setUsername("");
  };

  const clearFormulaireEnregistrementUtilisateur = () => {
    setNom("");
    setPrenoms("");
    setNumero("");
    setUsername("");
    setPassword("");
  };

  const getListeDesUtilisateurs = () => {
    setLoadingData(true);
    getListeUtilisateur(0, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setUserListe(res.data.donnee.utilisateurs);
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
      });
  };

  const ajoutNouvelUtilisateur = () => {
    setAddLoading(true);
    const data = {
      newPassword: password,
      nom: nom,
      prenoms: prenoms,
      numero: numero,
      password: password,
      passwordConfirm: password,
      username: username,
    };

    ajoutUtilisateur(data)
      .then((res) => {
        setSuccessMessage("Utilisateur enregistré avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-utilisateur").click();
        getListeDesUtilisateurs();
        clearFormulaireEnregistrementUtilisateur();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err && err.response) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Erreur d'enregistrement, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const modifierInfoUtilisateur = () => {
    setAddLoading(true);
    const data = {
      id: userInfo.id,
      nom: nom,
      prenoms: prenoms,
      numero: numero,
      username: username,
    };

    modificationUtilisateur(data)
      .then((res) => {
        setSuccessMessage("Utilisateur modifié avec succès");
        setSnackbarOpenSuccess(true);
        setAddLoading(false);
        document.getElementById("ajout-utilisateur").click();
        getListeDesUtilisateurs();
        clearFormulaireEnregistrementUtilisateur();
      })
      .catch((err) => {
        setAddLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        }
        setErrorMessage("Erreur de modification, rééssayer!");
        setSnackbarOpenError(true);
        console.log("api error", err);
      });
  };

  const supprimerUtilisateur = () => {
    setDeleteLoading(true);

    supprimerUtilisateurParId(userInfo.id)
      .then((res) => {
        setSuccessMessage("Utilisateur supprimé avec succès");
        getListeDesUtilisateurs();
        setSnackbarOpenSuccess(true);
        setDeleteLoading(false);
        document.getElementById("delete-warning").click();
      })
      .catch((err) => {
        setDeleteLoading(false);
        if (err.response.data) {
          setErrorMessage(err.response.data.donnee);
          setSnackbarOpenError(true);
        } else {
          setErrorMessage("Une erreur s'est produite, rééssayer!");
          setSnackbarOpenError(true);
        }
        console.log("api error", err);
      });
  };

  const changerEtatUtilisateur = () => {
    setDesactiveLoading(true);

    if (userInfo.enabled) {
      changerEtatUtilisateurParId(userInfo.id)
        .then((res) => {
          setSuccessMessage("Utilisateur désactivé avec succès");
          getListeDesUtilisateurs();
          setSnackbarOpenSuccess(true);
          setDesactiveLoading(false);
          document.getElementById("desactive-warning").click();
        })
        .catch((err) => {
          setDesactiveLoading(false);
          if (err.response.data) {
            setErrorMessage(err.response.data.donnee);
            setSnackbarOpenError(true);
          } else {
            setErrorMessage("Une erreur s'est produite, rééssayer!");
            setSnackbarOpenError(true);
          }
          console.log("api error", err);
        });
    } else {
      changerEtatUtilisateurParId(userInfo.id)
        .then((res) => {
          setSuccessMessage("Utilisateur activé avec succès");
          getListeDesUtilisateurs();
          setSnackbarOpenSuccess(true);
          setDesactiveLoading(false);
          document.getElementById("desactive-warning").click();
        })
        .catch((err) => {
          setDesactiveLoading(false);
          if (err.response.data) {
            setErrorMessage(err.response.data.donnee);
            setSnackbarOpenError(true);
          } else {
            setErrorMessage("Une erreur s'est produite, rééssayer!");
            setSnackbarOpenError(true);
          }
          console.log("api error", err);
        });
    }
  };

  const handleCloseSnackbarSuccess = () => {
    setSnackbarOpenSuccess(false);
  };

  const handleCloseSnackbarError = () => {
    setSnackbarOpenError(false);
  };

  const searchUtilisateur = () => {
    setSearchLoading(true);
    rechercherUtilisateurParParam(pageQuery.page, pageQuery.size, searchTerm)
      .then((res) => {
        setSearchLoading(false);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
        setUserListe(res.data.donnee.utilisateurs);
      })
      .catch((err) => {
        console.log("api error", err);
      });
  };

  const handlePaginationChange = (event, value) => {
    setLoadingData(true);
    setPageQuery((prev) => ({
      ...prev,
      page: value,
      pagePagination: value,
    }));
    if (searchTerm.length !== 0) {
      getListeUtilisateur(value - 1, pageQuery.size)
        .then((res) => {
          setUserListe(res.data.donnee.utilisateurs);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.donnee.totalPages,
          }));
          setLoadingData(false);
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
        });
    } else {
      getListeUtilisateur(value - 1, pageQuery.size, searchTerm)
        .then((res) => {
          setUserListe(res.data.donnee.utilisateurs);
          setPageQuery((prev) => ({
            ...prev,
            nombrePage: res.data.donnee.totalPages,
          }));
          setLoadingData(false);
        })
        .catch((err) => {
          setLoadingData(false);
          console.log("api error", err);
        });
    }
  };

  useEffect(() => {
    setLoadingData(true);
    getListeUtilisateur(pageQuery.page, pageQuery.size)
      .then((res) => {
        setLoadingData(false);
        setUserListe(res.data.donnee.utilisateurs);
        setPageQuery((prev) => ({
          ...prev,
          nombrePage: res.data.donnee.totalPages,
        }));
      })
      .catch((err) => {
        setLoadingData(false);
        console.log("api error", err);
        if (err.response && err.response.status === 401) {
          localStorage.removeItem("momo4scoohclient")
          navigate("/login")
        }
      });
  }, []);

  return (
    <BaseLayout>
      <div className="w-10/12 mx-auto pt-32">
        <h1 className="text-2xl text-black font-bold">Caissières</h1>
        <div className="mt-10">
          <div className="mb-5 flex items-center justify-between">
            <div>
              <p>Rechercher</p>
              <div className="flex items-center gap-x-2">
                <input
                  type="text"
                  disabled={searchLoading}
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  placeholder="Rechercher"
                  className="input input-bordered w-full max-w-xs"
                />
                <button
                  disabled={searchLoading}
                  className="w-14 h-11 bg-stone-800 text-white rounded-md flex items-center justify-center"
                  onClick={searchUtilisateur}
                >
                  {!searchLoading ? (
                    <SearchIcon />
                  ) : (
                    <TailSpin
                      height="25"
                      width="25"
                      color="#fff"
                      ariaLabel="tail-spin-loading"
                      radius="1"
                      wrapperStyle={{}}
                      wrapperClass=""
                      visible={searchLoading}
                    />
                  )}
                </button>
              </div>
            </div>
            <label
              htmlFor="ajout-utilisateur"
              className="bg-momo-blue text-white px-3 py-2 rounded-lg font-medium cursor-pointer"
              onClick={modalCreateUtilisateur}
            >
              Ajouter une caissière
            </label>
          </div>
          <div className="overflow-x-auto">
            <table className="table table-compact w-full mb-2">
              <thead>
                <tr>
                  <th className="capitalize py-4 px-4">Nom & prénoms</th>
                  <th className="capitalize py-4 px-4">Numéro</th>
                  <th className="capitalize py-4 px-4">Actions</th>
                </tr>
              </thead>
              <tbody>
                {!loadingData && userListe.length > 0 ? (
                  userListe.map((item) => (
                    <TableElement key={item.id} user={item} />
                  ))
                ) : !loadingData && userListe.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <ErrorOutlineIcon />
                        <p className="font-medium text-red-500">
                          Aucun élément trouvé
                        </p>
                      </div>
                    </td>
                  </tr>
                ) : loadingData && userListe.length === 0 ? (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                ) : (
                  <tr>
                    <td colSpan="3">
                      <div className="w-full h-32 bg-white rounded-br-lg rounded-bl-lg flex gap-x-2 text-red-500 items-center justify-center">
                        <TailSpin
                          height="50"
                          width="50"
                          color="#000"
                          ariaLabel="tail-spin-loading"
                          radius="1"
                          wrapperStyle={{}}
                          wrapperClass=""
                          visible={loadingData}
                        />
                      </div>
                    </td>
                  </tr>
                )}
              </tbody>
            </table>
            <div className="flex justify-end">
              <Pagination
                count={pageQuery.nombrePage}
                page={pageQuery.pagePagination}
                variant="outlined"
                shape="rounded"
                onChange={handlePaginationChange}
              />
            </div>
          </div>
        </div>
      </div>

      {/* MODAL AJOUT UTILISATEUR */}
      <input type="checkbox" id="ajout-utilisateur" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-lg">
            {userInfo === null
              ? "Ajouter une caissière"
              : "Modifier cette caissière"}
          </h3>
          <div className="py-4">
            <div>
              <label className="label">
                <span className="label-text">Nom</span>
              </label>
              <input
                disabled={addLoading}
                type="text"
                value={nom}
                onChange={(e) => setNom(e.target.value)}
                placeholder="Samuel"
                className="input input-bordered w-full"
              />
            </div>
            <div>
              <label className="label">
                <span className="label-text">Prénoms</span>
              </label>
              <input
                disabled={addLoading}
                type="text"
                value={prenoms}
                onChange={(e) => setPrenoms(e.target.value)}
                placeholder="Smith"
                className="input input-bordered w-full"
              />
            </div>
            <div>
              <label className="label">
                <span className="label-text">Numéro</span>
              </label>
              <input
                disabled={addLoading}
                type="number"
                value={numero}
                onChange={(e) => setNumero(e.target.value)}
                placeholder="0578227733"
                className="input input-bordered w-full"
              />
            </div>
            <div>
              <label className="label">
                <span className="label-text">Email</span>
              </label>
              <input
                disabled={addLoading}
                type="text"
                value={username}
                onChange={(e) => setUsername(e.target.value)}
                placeholder="exemple@gmail.com"
                className="input input-bordered w-full"
              />
            </div>
            {userInfo === null ? (
              <div>
                <label className="label">
                  <span className="label-text">Mot de passe</span>
                </label>
                <input
                  disabled={addLoading}
                  type="password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="*****"
                  className="input input-bordered w-full"
                />
              </div>
            ) : null}
          </div>
          <div className="modal-action">
            {!addLoading ? (
              <label
                htmlFor="ajout-utilisateur"
                className="bg-black text-white font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="ajout-utilisateur"
                className="bg-black text-white font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            {userInfo === null ? (
              <button
                disabled={addLoading}
                className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
                onClick={ajoutNouvelUtilisateur}
              >
                {!addLoading ? (
                  <span>Enregistrer</span>
                ) : (
                  <ThreeDots
                    height="20"
                    width="40"
                    radius="9"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={addLoading}
                  />
                )}
              </button>
            ) : (
              <button
                disabled={addLoading}
                className="bg-momo-jaune text-black font-bold px-4 py-2 rounded-md"
                onClick={modifierInfoUtilisateur}
              >
                {!addLoading ? (
                  <span>Modifier</span>
                ) : (
                  <ThreeDots
                    height="20"
                    width="40"
                    radius="9"
                    color="#000"
                    ariaLabel="three-dots-loading"
                    wrapperStyle={{}}
                    wrapperClassName=""
                    visible={addLoading}
                  />
                )}
              </button>
            )}
          </div>
        </div>
      </div>

      {/* SUPPRIMER UTILISATEUR */}
      <input type="checkbox" id="delete-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3 className="font-bold text-2xl text-center text-red-500">
            Attention !
          </h3>
          <p className="text-lg text-center py-4">
            Cette action est irréversible
          </p>
          <div className="modal-action flex justify-center gap-x-5">
            {!deleteLoading ? (
              <label
                id="delete-warning-btn"
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="delete-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={deleteLoading}
              className="bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              onClick={supprimerUtilisateur}
            >
              {!deleteLoading ? (
                <span>Supprimer</span>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={deleteLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* DESACTIVER UTILISATEUR */}
      <input type="checkbox" id="desactive-warning" className="modal-toggle" />
      <div className="modal">
        <div className="modal-box">
          <h3
            className={
              userInfo && userInfo.enabled
                ? "font-bold text-2xl text-center text-red-500"
                : "font-bold text-2xl text-center text-green-500"
            }
          >
            {userInfo && userInfo.enabled
              ? "Désactiver cette caissière"
              : "Activer cette caissière"}
          </h3>
          {/* <p className="text-lg text-center py-4">
            {userInfo && userInfo.enabled
              ? "Cet utilisateur sera désactiver et ne pourra se connecter"
              : "Cet utilisateur sera à nouveau activé"}
          </p> */}
          <div className="modal-action flex justify-center gap-x-5">
            {!desactiveLoading ? (
              <label
                id="desactive-warning-btn"
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md cursor-pointer"
              >
                Annuler
              </label>
            ) : (
              <label
                htmlFor="desactive-warning"
                className="bg-gray-300 text-black font-bold px-4 py-2 rounded-md pointer-events-none"
              >
                Annuler
              </label>
            )}
            <button
              disabled={desactiveLoading}
              className={
                userInfo && userInfo.enabled
                  ? "bg-red-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
                  : "bg-green-500 text-white font-bold px-4 py-2 rounded-md flex items-center justify-center"
              }
              onClick={changerEtatUtilisateur}
            >
              {!desactiveLoading ? (
                <>
                  {userInfo && userInfo.enabled ? (
                    <span>Désactiver</span>
                  ) : (
                    <span>Activer</span>
                  )}
                </>
              ) : (
                <ThreeDots
                  height="20"
                  width="40"
                  radius="9"
                  color="#fff"
                  ariaLabel="three-dots-loading"
                  wrapperStyle={{}}
                  wrapperClassName=""
                  visible={desactiveLoading}
                />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* SNACKBAR SUCCESS */}
      {successMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarSuccessOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarSuccess}
          key={vertical + horizontal}
        >
          <div className="bg-green-500 text-white px-10 py-3 rounded-lg">
            {successMessage}
          </div>
        </Snackbar>
      ) : null}

      {/* SNACKBAR ERROR */}
      {errorMessage ? (
        <Snackbar
          anchorOrigin={{ vertical, horizontal }}
          open={snackbarErrorOpen}
          autoHideDuration={2000}
          onClose={handleCloseSnackbarError}
          key={vertical + horizontal}
        >
          <div className="bg-red-500 text-white px-10 py-3 rounded-lg">
            {errorMessage}
          </div>
        </Snackbar>
      ) : null}
    </BaseLayout>
  );
};

export default Caissiere;
